import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHeartGraph = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21.375 17V11.375H15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 11.375L14.7592 17.9908C14.6431 18.107 14.5052 18.1991 14.3535 18.262C14.2018 18.3249 14.0392 18.3572 13.875 18.3572C13.7108 18.3572 13.5482 18.3249 13.3965 18.262C13.2448 18.1991 13.1069 18.107 12.9908 17.9908L10.3842 15.3842C10.2681 15.268 10.1302 15.1759 9.97854 15.113C9.82683 15.0501 9.66422 15.0178 9.5 15.0178C9.33578 15.0178 9.17317 15.0501 9.02146 15.113C8.86975 15.1759 8.73192 15.268 8.61583 15.3842L2.625 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.62506 11.375L3.36339 6.92916C2.98911 6.55511 2.74212 6.0727 2.65746 5.55036C2.57279 5.02802 2.65476 4.49229 2.89172 4.01916V4.01916C3.07036 3.66186 3.33135 3.35212 3.65318 3.11548C3.97502 2.87885 4.34849 2.72208 4.7428 2.65811C5.13712 2.59414 5.54099 2.6248 5.92113 2.74756C6.30127 2.87031 6.6468 3.08166 6.92923 3.36416L7.62506 4.06L8.32089 3.36416C8.6034 3.08166 8.94899 2.87032 9.32919 2.74757C9.70939 2.62482 10.1133 2.59416 10.5077 2.65813C10.9021 2.72209 11.2756 2.87885 11.5975 3.11548C11.9194 3.35211 12.1805 3.66185 12.3592 4.01916V4.01916C12.5958 4.49243 12.6775 5.02816 12.5927 5.55044C12.5079 6.07272 12.2609 6.55507 11.8867 6.92916L7.62506 11.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHeartGraph.displayName = 'SvgHeartGraph';
export default SvgHeartGraph;
